module.exports = __webpack_public_path__ + "img/acc_carousel_06.e2d705aa.jpg";